/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { RecommendationByDemand } from './recommendationByDemand';
import { SectionChange } from './sectionChange';

export class SectionRecommendation extends DaoModel {
  constructor(guid, recommendations_by_demand, confirmed, nameAlt1, nameAlt2, nameAlt3) {
    super(guid);
    this.recommendations_by_demand = recommendations_by_demand || [];
    this.confirmed = confirmed;
    this.recommendation_confirmed = confirmed;
    this.menuProductGuids = this.#initializeMenuProductGuids();
    this.nameAlt1 = nameAlt1 || '';
    this.nameAlt2 = nameAlt2 || '';
    this.nameAlt3 = nameAlt3 || '';
  }

  static toInstance(props = {}) {
    const recommendations_by_demand = RecommendationByDemand.toInstanceList(props.recommendations_by_demand);
    return new SectionRecommendation(props.guid, recommendations_by_demand, props.confirmed,
      props.name_alt1, props.name_alt2, props.name_alt3);
  }

  serialize() {
    return {
      ...super.serialize(),
      recommendations_by_demand: this.recommendations_by_demand.map((recommendation) => recommendation.serialize()),
      confirmed: this.confirmed,
      name_alt1: this.nameAlt1,
      name_alt2: this.nameAlt2,
      name_alt3: this.nameAlt3,
    };
  }

  get name() {
    return this.nameAlt1;
  }

  hasChange() {
    return this.confirmed !== this.recommendation_confirmed || this.recommendations_by_demand.some((r) => r.hasChange());
  }

  getRecommendationByDemand(groupCodeName) {
    return this.recommendations_by_demand.find((dem) => dem.code_name === groupCodeName);
  }

  getSectionLabelForDemand(groupCodeName) {
    const recommendationByDemand = this.getRecommendationByDemand(groupCodeName);
    return (recommendationByDemand?.getVisibleProductsLabel() || '');
  }

  getChange() {
    const menuProductChanges = this.recommendations_by_demand.flatMap((recommendationByDemand) => recommendationByDemand.getChanges());
    return new SectionChange(this.guid, this.confirmed, menuProductChanges);
  }

  #initializeMenuProductGuids() {
    const menuProductGuids = new Set();
    this.recommendations_by_demand.forEach((demand) => demand.services.forEach((service) => service.products.forEach((product) => menuProductGuids.add(product.guid))));
    return menuProductGuids;
  }
}
